export const LANGUAGE = {
    ENGLISH: 'en',
    VIETNAMESE: 'vi',
    KOREAN: 'ko',
};

export const LANGUAGES = [LANGUAGE.ENGLISH, LANGUAGE.VIETNAMESE, LANGUAGE.KOREAN];